import React from 'react'
import { jt, t } from 'ttag'

import { DeleteResourceModal } from 'components/modals/common/DeleteResourceModal/DeleteResourceModal'

export const DeleteJobModal = ({
  name,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const position = <strong key="position">{name}</strong>

  return (
    <DeleteResourceModal
      alert={jt`You are deleting a ${position} job position. This will result in the deletion of all candidates assigned to this job.`}
      message={t`Are you sure you want to delete?`}
      title={t`Delete job`}
      {...{ onCancel, onClose, onConfirm, isOpen }}
    />
  )
}
